{
  "$source": "Web Developer Implementation Guide.docx + NMS_Web_Pricing_Logic_v11.xlsx (Garment Pricing Requirement folder, Dropbox)",
  "id": "garments",
  "label": "Custom Apparel (DTF)",
  "type": "garment-formula",
  "constants": {
    "markupMultiplier": 1.5,
    "firstDecalFee": 10.0,
    "additionalDecalFee": 5.0,
    "oversizedDecalSurcharge": 3.0,
    "sleeveDecalSurcharge": 2.0,
    "microRunPremium": 10.0,
    "microRunFloor": 35.0,
    "personalizationFee": 1.5,
    "baggingFee": 1.0,
    "customerGarmentHandlingFee": 5.0,
    "flightCheckProofFee": 39.0,
    "designSupportHourly": 89.0,
    "localCourierMinimum": 20.0,
    "quoteValidDays": 14
  },
  "rules": {
    "$comment": "Choices where the guide and spreadsheet disagree. See ../docs/open-questions.md.",
    "sleeveSurchargeStage": "base",
    "tierQuantityScope": "line"
  },
  "quantityTiers": [
    { "min": 1, "max": 2, "multiplier": 1.0, "label": "1-2 (micro-run)", "microRun": true },
    { "min": 3, "max": 9, "multiplier": 1.0, "label": "3-9" },
    { "min": 10, "max": 24, "multiplier": 0.9, "label": "10-24 (-10%)" },
    { "min": 25, "max": 49, "multiplier": 0.8, "label": "25-49 (-20%)" },
    { "min": 50, "max": null, "multiplier": 0.67, "label": "50+ (-33%)" }
  ],
  "sizes": [
    { "id": "YS", "label": "Youth S", "upcharge": 0 },
    { "id": "YM", "label": "Youth M", "upcharge": 0 },
    { "id": "YL", "label": "Youth L", "upcharge": 0 },
    { "id": "YXL", "label": "Youth XL", "upcharge": 0 },
    { "id": "XS", "label": "Adult XS", "upcharge": 0 },
    { "id": "S", "label": "Adult S", "upcharge": 0 },
    { "id": "M", "label": "Adult M", "upcharge": 0 },
    { "id": "L", "label": "Adult L", "upcharge": 0 },
    { "id": "XL", "label": "Adult XL", "upcharge": 0 },
    { "id": "2XL", "label": "2XL", "upcharge": 3 },
    { "id": "3XL", "label": "3XL", "upcharge": 4 },
    { "id": "4XL", "label": "4XL", "upcharge": 5 },
    { "id": "5XL", "label": "5XL", "upcharge": 6 }
  ],
  "placements": [
    { "id": "front", "label": "Front Full Chest", "kind": "large", "maxIn": [10, 12] },
    { "id": "back", "label": "Full Back", "kind": "large", "maxIn": [10, 12] },
    { "id": "left-chest", "label": "Left Chest", "kind": "small", "maxIn": [5, 5] },
    { "id": "right-chest", "label": "Right Chest", "kind": "small", "maxIn": [5, 5] },
    { "id": "right-sleeve", "label": "Right Sleeve", "kind": "small", "maxIn": [5, 5], "sleeve": true },
    { "id": "left-sleeve", "label": "Left Sleeve", "kind": "small", "maxIn": [5, 5], "sleeve": true },
    { "id": "other", "label": "Other (describe)", "kind": "large", "maxIn": [10, 12], "requiresNote": true }
  ],
  "artwork": {
    "mime": "image/png",
    "minDpi": 300,
    "sizeToleranceIn": 0.2
  },
  "rush": [
    { "id": "standard", "label": "Standard production", "multiplier": 1.0 },
    { "id": "rush", "label": "Rush (3-5 days) +20%", "multiplier": 1.2 },
    { "id": "hot", "label": "Hot Rush (48 hours) +50%", "multiplier": 1.5 }
  ],
  "delivery": {
    "$comment": "PLACEHOLDER ZIP list. Confirm Warren County ZIPs with NMS before launch.",
    "courierZips": ["22630", "22610", "22642"],
    "methods": [
      { "id": "pickup", "label": "Local Will-Call / Studio Pickup", "price": 0 },
      { "id": "courier", "label": "Local Courier Delivery (Warren County)", "price": 20, "minimum": true, "requiresLocalZip": true },
      { "id": "ship", "label": "Standard Shipping", "price": null, "carrierCalculated": true }
    ]
  },
  "catalog": {
    "$comment": "SAMPLE wholesale costs from the 'Rounded Pricing Matrix' sheet. Production should pull live costs from SanMar / Atlantic Coast Cotton.",
    "products": [
      { "id": "promo-tee", "label": "Basic Promo Tee", "wholesale": 2.95, "colors": ["White", "Black", "Navy", "Sport Grey", "Red"] },
      { "id": "blend-tee", "label": "Standard Blend Shirt", "wholesale": 5.5, "colors": ["White", "Black", "Heather Navy", "Heather Grey"] },
      { "id": "fleece-hoodie", "label": "Premium Fleece Hoodie", "wholesale": 16.0, "colors": ["Black", "Navy", "Sport Grey", "Maroon"] },
      { "id": "quarter-zip", "label": "Athletic Quarter-Zip", "wholesale": 24.0, "colors": ["Black", "Navy", "Royal", "Charcoal"] }
    ]
  }
}
